<template>
<div class="customerInfo" style="height: 100%;">
	<wc-header headerTitle="客户信息" :BackisShow=BackisShow></wc-header>
	<div class="page">
		<div class="itemInline itemRealName">
			<div class="itemLineTit">
				<span>真实姓名</span> <input v-model="realName"  class="inputSty" placeholder="请输入真实姓名" maxlength="20" />
			</div>
		</div>
		<div class="itemInline">
			<div class="itemLineTit">
				<span>手机号</span> <input v-model="mobilePhone"  class="inputSty" placeholder="请输入手机号" />
			</div>
		</div>
		<!--<div class="itemDesc">
			<div class="itemDescIit">
				<img src="../../assets/images/questionDescribe.png" height="17" width="13"  style="margin-right: 5px;" />
				问题简述
			</div>
			<div>
				<textarea v-model="questionDesc"  class="areaSty" placeholder="请输入问题简述，最长200个字符" maxlength="200"></textarea>
			</div>
		</div> -->
		<div class="cfmBtn" @click="submitInfo">
			确定
		</div>
	</div>
</div>
</template>

<script>
	import {_api} from '@/service/interface'
	import { Toast,MessageBox  } from 'mint-ui';
	export default{
		name:'CustomerSer',
		data(){
			return{
				flag:'',
				realName:'',
				mobilePhone:'',
				//questionDesc:'',
				BackisShow:true,
				duration:3000,
				position:'bottom'
			}
		},
		methods:{
			loadInfo(){
				_api('_chatname','.code',{mark:"getReferenceInfo"},res=>{
					if(res.data){
						if(res.data.realName){
							this.realName = res.data.realName;
						}
						if(res.data.mobilePhone){
							this.mobilePhone = res.data.mobilePhone;
						}
						/*if(res.data.questionDesc){
							this.questionDesc = res.data.questionDesc;
						}*/
					}
				},err=>{
					
				})
			},
			submitInfo(){
				var regCell = /^1\d{10}$/;
        var regRealName = /^[\u4e00-\u9fa5]{1,20}$/;
				this.realName = this.realName.trim();
				this.mobilePhone = this.mobilePhone.trim();
				//this.questionDesc = this.questionDesc.trim();
				if(!this.realName){
					Toast({
					  message: '请输入真实姓名',
					  position: this.position,
					  duration: this.duration
					});
					return;
				}
				if(!regRealName.test(this.realName)){
					Toast({
					  message: '真实姓名输入不合法，请输入1-20位中文字符',
					  position: this.position,
					  duration: this.duration
					});
					return;
				}
				if(this.mobilePhone){
					if(!regCell.test(this.mobilePhone)){
						Toast({
							message: '手机号输入不合法',
							position: this.position,
							duration: this.duration
						});
						return;
					}
				}
				/*if(!this.questionDesc){
					Toast({
					  message: '请输入问题简述',
					  position: this.position,
					  duration: this.duration
					});
					return;
				}*/
				_api('_chatname','.code',{mark:"setReferenceInfo",realName:this.realName,mobilePhone:this.mobilePhone},res=>{
					if(res.data){
						if(res.data.result=="ok"){
							this.$router.push('/chatBox?flag='+this.flag);
						}
					}
				},err=>{
					
				})
			}
			
		},
		mounted:function(){
			if(this.$route.query.flag){
				this.flag=this.$route.query.flag;
			}
			this.loadInfo();
		}
	}
</script>

<style>
	.customerInfo{
		background: #F3F3F3;
	}
	body{
		width: 100%;
		height: 100%;
		background-size: 100% 100%;
	}
	.page{
		padding-top: 1px;
		position: relative;
		top: 40px;
	}
	.page .itemInline{
		height: 40px;
		margin-top: 10px;
		background: #FFFFFF;
		border-top: 1px solid #DBDBDB;
		border-bottom: 1px solid #DBDBDB;
		padding: 0px 10px 0px 20px;
	}
	.page .itemRealName{
		margin-top: 5px;
	}
	.page .inputSty{
		width: 85%;
		height: 20px;
		border: 1px solid #DBDBDB;
		background: #F7F7F7;
		padding: 5px;
	}
	.page .itemLineTit{
		height: 40px;
		display: flex;
		align-items: center;
		color: #5B5B5B;
		font-size: 15px;
	}
	.page .itemLineTit span{
		width:90px;
	}
	.page .itemDesc{
		height: 200px;
		margin-top: 10px;
		background: #FFFFFF;
		border-top: 1px solid #DBDBDB;
		border-bottom: 1px solid #DBDBDB;
		padding: 0 20px;
	}
	.page .areaSty{
		width: 100%;
		height: 135px;
		border: 1px solid #DBDBDB;
		background: #F7F7F7;
		padding: 5px;
	}
	.page .itemDescIit{
		height: 40px;
		display: flex;
		align-items: center;
		color: #5B5B5B;
		font-size: 15px;
	}
	textarea::-webkit-input-placeholder{
	    color:#BABABA;
		
	}
	textarea::-moz-placeholder{   /* Mozilla Firefox 19+ */
	    color:#BABABA;
	}
	textarea:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
	    color:#BABABA;
	}
	textarea:-ms-input-placeholder{  /* Internet Explorer 10-11 */ 
	    color:#BABABA;
	}
	.page .cfmBtn{
		width: 70%;
		height: 40px;
		background:#31B0D3;
		border-radius: 40px;
		margin: 40px auto;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		font-size: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/views/customerSer/CustomerSer.vue